export default {
  APP_STORE_LINK_CLICKED: "App Store Link - Clicked",
  APP_LINK_CLICKED: "App Link - Clicked",
  LOAD_MORE_CLICKED: "Load More - Clicked",
  READ_MORE_ARTICLES_CLICKED: "Read More Articles - Clicked",
  SEE_MORE_OFFERS_CLICKED: "See More Offers - Clicked",
  COOKIE_CONSENT_ACCEPTED: "Cookie Consent - Accepted",
  SHOWCASE_ITEM_VIEWED: "Showcase Item - Viewed",
}
